import React, {Component} from "react"
import {changeQuerySearch, parseSearchQuery} from "../../../../helpers/routes/RouterHelper";
import {_getListTeams} from "../../../../services/apis/AdminServices";
import FormSearchTeams from "./FormSearchTeams";
import TeamPagination from "./TeamPagination";
import TeamItem from "./TeamItem";
import {Alert} from "reactstrap";

const getInitPage = () => {
    const parsedQuery = parseSearchQuery();
    return !!parsedQuery.page ? parseInt(parsedQuery.page, 10) : 1
}

class TeamsPage extends Component {
    state = {
        query: {},
        teams: [],
        total: 0,
        pagination: {
            page: getInitPage(),
            pages: 1,
            limit: 100,
        },
        needFetch: false,
        error: ''
    }

    componentDidMount() {
        this._fetchListTeams()
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.needFetch) {
            return this._fetchListTeams()
        }
    }

    _fetchListTeams = () => {
        const {query, pagination} = this.state
        const {page, limit} = pagination

        this.setState({needFetch: false})

        return _getListTeams({query, page, limit})
            .then(response => {
                const {success, data, message} = response

                if (success) {
                    const {page, pages, limit, total, docs} = data

                    this.setState({
                        teams: docs,
                        total,
                        pagination: {
                            page,
                            pages,
                            limit
                        }
                    })
                } else {
                    this.setState({error: message})
                }
            })
            .catch(error => {
                console.log(error);
            })
    }

    _handleChangeQuery = (query) => {
        this.setState(({pagination}) => ({
            needFetch: true,
            query,
            pagination: {
                ...pagination,
                page: 1
            }
        }))
    }

    _handleChangePage = (page) => {
        const {query, pagination} = this.state
        const {limit} = pagination

        changeQuerySearch({page})

        this.setState(({pagination}) => ({
            needFetch: true,
            pagination: {
                ...pagination,
                page: parseInt(page, 10)
            }
        }))

        _getListTeams({query, page, limit})
            .then(response => {
                const {success, data, message} = response

                if (success) {
                    const {page, pages, limit, total, docs} = data

                    this.setState({
                        teams: docs,
                        total,
                        pagination: {
                            page,
                            pages,
                            limit
                        }
                    })
                } else {
                    this.setState({error: message})
                }
            })
    }

    render() {
        const {teams, total, pagination, error} = this.state
        const {page, pages, limit} = pagination

        return (
            <div>
                {error ? <Alert color="danger">{error}</Alert> :
                    <div id="ListTeamsPage">
                        <h1>Teams ({total})</h1>

                        <FormSearchTeams onChangeQuery={this._handleChangeQuery}/>

                        <table className="table">
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Master</th>
                                <th>Members</th>
                                <th>Subscription</th>
                                <th>Total Login</th>
                                <th>Notes</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                teams.map((team, index) => {
                                    const order = (page - 1) * limit + index + 1

                                    return <TeamItem order={order} key={team._id} data={team}/>
                                })
                            }
                            </tbody>
                        </table>

                        <TeamPagination page={page} pages={pages} onChangePage={this._handleChangePage}/>
                    </div>
                }
            </div>
        )
    }
}

export default TeamsPage


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/teams/TeamsPage.js